import { login, getInfo, logout } from '@api/login'
import {
  getToken,
  setToken,
  removeToken,
  setAccount,
  setPassword,
  removeAccount,
  removePassword,
  setRole,
} from '@utils/auth'
import {
  SET_TOKEN,
  SET_USER_INFO,
  SET_WID,
  SET_TRAINER_INFO,
  SET_SHOW_TRAINER_WECHAT,
  SET_IS_EXPIRED,
} from '../mutation-types'
import { SUCCESS } from '@src/constant/request'
import { encryption } from '@/utils/crypto'
import { Message } from 'element-ui'
// import { AccountType } from '@/constant/user'

const user = {
  state: {
    token: getToken(),
    userInfo: {
      roles: [],
    },
    wid: '',
    twQrcode: '', // 训练师微信
    phone: '', // 训练师电话
    showTrainerWechat: false,
    isExpire: false,
  },
  getters: {
    hid: state => state.userInfo.hid,
    age: state => state.userInfo.age,
    gender: state => state.userInfo.gender,
    uid: state => state.userInfo.sdxUid,
    pid: state => state.userInfo.pid,
    name: state => state.userInfo.fullName,
    role: state => state.userInfo.role, // ROLE 已经是字符串了
    openDay: state => state.userInfo.openDay,
    usedDay: state => state.userInfo.usedDay,
    dailyTrainDuration: state => state.userInfo.dailyTrainLimit,
    singleTrainDuration: state => state.userInfo.singleTrainLimit,
    twQrcode: state => state.userInfo.twQrcode,
    phone: state => state.userInfo.phone,
    address: state => state.userInfo.address,
    renewalQrCode: state => state.userInfo.renewalQrCode,
    avgLoadTime: state => state.userInfo.avgLoadTime,
    isExpire: state => {
      return (
        new Date().getTime() - new Date(state.userInfo.endTime).getTime() > 0
        // state.userInfo.openDay - state.userInfo.usedDay === 0
        // [AccountType.BASIS, AccountType.ADVANCED, AccountType.MYOPIA].includes(
        //   state.userInfo.role
        // )
      )
    },
    hospitalInfo: state => state.userInfo.hospital,
  },
  mutations: {
    [SET_TOKEN](state, token) {
      state.token = token
    },
    [SET_USER_INFO](state, userInfo) {
      state.userInfo = userInfo
    },
    [SET_WID](state, wid) {
      state.wid = wid
    },
    [SET_TRAINER_INFO](state, data) {
      state.twQrcode = data.twQrcode
      state.phone = data.phone
    },
    [SET_SHOW_TRAINER_WECHAT](state, showTrainerWechat) {
      state.showTrainerWechat = showTrainerWechat
    },
    [SET_IS_EXPIRED](state, isExpire) {
      state.isExpire = isExpire
    },
  },
  actions: {
    async Login({ commit }, loginInfo) {
      // 登录密码加密
      const user = encryption({
        data: loginInfo,
        encryptArr: ['password'],
      })
      try {
        // 获取token
        const res = await login({
          username: user.account.trim(),
          password: user.password,
          device: loginInfo.device,
          broswer: loginInfo.broswer,
        })

        // 记住密码的逻辑
        if (res.code === SUCCESS) {
          if (loginInfo.remember) {
            setAccount(loginInfo.account.trim())
            setPassword(loginInfo.password)
          } else {
            removeAccount()
            removePassword()
          }

          //保存token 到本地和store
          commit(SET_TOKEN, res.data.token)
          setToken(res.data.token)
        } else {
          Message.error(res.message)
        }
      } catch (error) {
        console.log(error)
        return Promise.reject(error)
      }
    },
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            const { data } = await getInfo()
            const userInfo = data
            commit(SET_USER_INFO, userInfo)
            setRole(userInfo.role)
            resolve(userInfo)
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })()
      })
    },
    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            await logout()
            commit(SET_TOKEN, '')
            removeToken()
            resolve()
          } catch (error) {
            console.log(error)
            reject(error)
          }
        })()
      })
    },
    FeLogout({ commit }) {
      return new Promise(resolve => {
        commit(SET_TOKEN, '')
        removeToken()
        resolve()
      })
    },
  },
}

export default user
